export default __webpack_public_path__ + "static/media/virtual-bg17.4026fbe2.png";